import { gql } from '@apollo/client';

export interface ILibraryCuisineType {
  name: string;
  id: string;
}

export const LibraryCuisineTypeFragment = gql`
  fragment LibraryCuisineType on LibraryCuisineType {
    name
    sys {
      id
    }
  }
`;
